<script>
import {onMounted, ref} from "vue";
import axios from "axios";
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";

export default {
    setup() {
        const {$route} = useTools();
        const {getBack} = useSharedMethod();
        const {dialog, loading} = useSharedData();
        
        const pdfUrl = ref(null);
        
        function download(id) {
            loading.value = true;
            axios.get(`/sage/paySlips/download/${id}`, {responseType: 'blob'}).then(response => {
                pdfUrl.value = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
            }).finally(() => {
                loading.value = false
            });
        }
        
        
        onMounted(() => download($route.params.id));
        
        return {
            dialog,
            loading,
            pdfUrl,
            getBack
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="1000"
        scrollable
    >
        <v-card>
            <w-toolbar color="teal"/>
            <v-card-text>
                <v-container fluid>
                    <iframe
                        v-if="pdfUrl"
                        :src="pdfUrl"
                        width="100%"
                        height="600px"
                        ref="pdfIframe"
                    />
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<style scoped>

</style>